import React, { useEffect, useState } from "react";
import GlassCard from "./GlassCard";
import heroImg from "../assets/hero-doctor.jpg"; // put your image here
import { heroContent } from "../data/heroContent";
import { useNavigate } from "react-router-dom";
import { useCurrentLang } from "../hooks/useCurrentLang";
const Hero = ({ lang = "sl" }) => {
  const navigate = useNavigate();
  const currentLang = useCurrentLang();
  const t = heroContent[lang];
  const [fade, setFade] = useState(0); // 0 = full image, 1 = fully faded

  const max = 600; // how many pixels to finish fade (tune this)

  useEffect(() => {
    const onScroll = () => {
      const ratio = Math.min(window.scrollY / max, 1); // 0 → 1
      setFade(ratio);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);


  const opacity = 0.85 * (1 - fade) + 0 * fade; // from 0.85 to 0.2

  const goSignUp = () => {
    navigate(`/${currentLang}/sign-up`)
  }

  return (
    <section
      style={{
        position: "relative",
        minHeight: "100vh",
        paddingTop: "120px",
        paddingBottom: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "visible",
      }}
    >
      {/* Background image kept in place */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          backgroundImage: `url(${heroImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity,
          transition: "opacity 0.25s ease-out",
          pointerEvents: "none",
          zIndex: "-1"
        }}
      />

      {/* Soft overlay for readability */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, #176B87 0%, #EEF5FF 60%, #EEF%FF",
        }}
      />

      {/* Content */}
      <div
        className="container"
        style={{ position: "relative", zIndex: 1, maxWidth: 800 }}
      >
        <GlassCard
          style={{
            textAlign: "center",
            padding: "40px 32px 36px",
            borderRadius: 32,
            color: "white",
            minWidth: "600px"
          }}
        >
          <h1
            style={{
              margin: "0 0 16px",
              fontSize: "clamp(32px, 4vw, 40px)",
              fontWeight: 700,
            }}
          >
            {t.title.line1}
            <br />
            {t.title.line2}
          </h1>

          <p
            style={{
              margin: "0 0 28px",
              fontSize: 16,
              lineHeight: 1.6,
              color: "rgba(255,255,255,0.9)",
            }}
          >
            {t.subtitle}
          </p>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 16,
            }}
          >
            <button
              style={{
                padding: "12px 26px",
                borderRadius: "999px",
                backgroundColor: "var(--primary)",
                color: "white",
                fontWeight: 600,
                minWidth: 160,
              }}
              onClick={goSignUp}
            >
              {t.getStarted}
            </button>

          </div>
        </GlassCard>

        {/* Scroll arrow */}
        <div
          style={{
            marginTop: 32,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            className="scroll-arrow"
            style={{
              width: 32,
              height: 32,
              borderRadius: "999px",
              border: "2px solid #EEF5FF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#EEF5FF",
              animation: "bounce 1.4s infinite",
            }}
          >
            ˅
          </div>
        </div>
      </div>

      <style>
        {`
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(6px); }
        }
        `}
      </style>
    </section>
  );
};

export default Hero;
